import { Translator } from '~domain/i18n';

// Define the structure of a form
export type FormContent = string | number | boolean | object | FormContent[];

// Define which methods every form converter must respects
export abstract class FormConverter<T> {
  protected translator: Translator;

  constructor(translator: Translator) {
    this.translator = translator;
  }

  // Convert form data to object
  abstract convertFormContent(formContent: FormContent): T;

  // FIXME: Most of our form converter still use the T type.
  // When every form converter uses the Partial<T> as type, remove the T
  abstract convertObject(object: Partial<T> | T): FormContent;
}
